const templateUrl = require("ngtemplate-loader!html-loader!./mantenedor.component.html")

angular.module("appModule").component("mantenedor", {
  templateUrl: templateUrl,
  bindings: {
    modelName: "<",
    columns: "<",
    menuOptions: "<",
    crudMenu: "<",
    getModels: "<",
    onDelete: "<",
    onEdit: "<",
    onCreate: "<",
    createModel: "<",
    refresh: "<",
    refreshCallback: "<",
    maxRows: "<",
    clickOnrow: "<"
  },
  controller: [
    "formularioService",
    "$state",
    function MantenedorController(formularioService, $state) {
      var self = this

      self.$onInit = function() {
        self.callback_config = {
          editRow: self._editRow,
          deleteRow: self._deleteRow,
          create: self.createForm,
          delete: self.deleteForm,
          editModels: self.editModels,
          goToStudentProfile: self.goToStudentProfile,
          goToAttentionDetail: self.goToAttentionDetail,
          goToAlertDetail: self.goToAlertDetail,
          viewComments: self.viewComments,
          addComment: self.addComment
        }
        self._reloadTable = 0
        self._deleteModels = 0
        self._editModels = 0
        self.ev_caller = null
        self.ev_caller_property = null

        self.initTableMenuOptions()
      }

      self.initTableMenuOptions = function() {
        var keys = Object.keys(self.menuOptions)
        var name, callback, args

        self.tableMenuOptions = []

        for (var i in keys) {
          name = self.menuOptions[keys[i]]["name"]

          if (self.menuOptions[keys[i]]["callback"] === "custom") {
            callback = self.menuOptions[keys[i]]["args"]
          } else {
            callback = self.callback_config[self.menuOptions[keys[i]]["callback"]]
            args = self.menuOptions[keys[i]]["args"]
          }
          self.tableMenuOptions.push({
            name: name,
            callback: callback,
            args: args
          })
        }
      }

      self._editRow = function(row, property) {
        self.ev_caller = null
        self.ev_caller_property = property
        self.editForm([row])
      }

      self._deleteRow = function(row) {
        self.onDeleteResolve([row.id])
      }

      self.goToStudentProfile = function(row) {
        $state.go("app.profile", { studentId: row.alumno_id })
      }

      self.goToAlertDetail = function(row) {
        $state.go("app.profile.alert", { studentId: row.alumno_id, alertId: row.id })
      }

      self.goToAttentionDetail = function(row) {
        $state.go("app.profile.attention", {
          studentId: row.alumno_id,
          attentionId: row.id
        })
      }

      self.reloadTable = function() {
        self._reloadTable += 1
      }

      self.editModels = function(ev, property) {
        self._editModels += 1
        self.ev_caller = ev
        self.ev_caller_property = property
      }

      self.deleteModels = function() {
        self._deleteModels += 1
      }

      self.viewComments = function() {
        console.log("mostrando comentarios")
      }

      self.onCreateResolve = function(post_data, callback) {
        self
          .onCreate(post_data, callback)
          .then(function(data) {
            console.log(data)
            self.reloadTable()
          })
          .catch(function() {
            console.log("ERROR crear el registro")
          })
      }

      self.onDeleteResolve = function(models) {
        self
          .onDelete(models)
          .then(function(data) {
            self.reloadTable()
            if (self.refreshCallback) {
              self.refreshCallback()
            }
          })
          .catch(function() {
            console.log("ERROR al eliminar registros")
          })
      }

      self.onEditResolve = function(models, callback) {
        self
          .onEdit(models, callback)
          .then(function(data) {
            self.reloadTable()
            if (self.refreshCallback) {
              self.refreshCallback()
            }
          })
          .catch(function() {
            console.log("Error al modificar los registros seleccionados")
          })
      }

      self.addComment = function(models) {
        formularioService.showPopup(
          self.ev_caller,
          {
            modelName: self.modelName,
            actionName: "comentario"
          },
          {
            models: models,
            saveCallback: function() {
              console.log(models)
            }
          }
        )
      }

      self.editForm = function(models) {
        formularioService.showPopup(
          self.ev_caller,
          {
            modelName: self.modelName,
            actionName: self.ev_caller_property
          },
          {
            models: models,
            saveCallback: self.onEditResolve
          }
        )
      }

      self.createForm = function(ev, property) {
        self.ev_caller = ev
        self.ev_caller_property = property

        formularioService.showPopup(
          self.ev_caller,
          {
            modelName: self.modelName,
            actionName: self.ev_caller_property
          },
          {
            saveCallback: self.onCreateResolve
          }
        )
      }

      self.deleteForm = function(ev, property) {
        self.ev_caller = ev
        self.ev_caller_property = property

        formularioService.showPopup(
          self.ev_caller,
          {
            modelName: self.modelName,
            actionName: self.ev_caller_property
          },
          {
            saveCallback: self.deleteModels
          }
        )
      }

      self.openMenu = function($mdOpenMenu, ev) {
        $mdOpenMenu(ev)
      }

      self.$onChanges = function(data) {
        if (self.createModel) {
          if (self.createModel > 0) {
            self.createForm(null, "crear")
          }
        }
        if (data["refresh"]) {
          self.reloadTable()
        }
      }
    }
  ]
})
